define('views/nav/nav',[
  "globals",
  "backbone"
], function (globals, Backbone) {
  "use strict";

  return Backbone.View.extend({
    events: {
      "click a[href = #toc]": "setActiveTocItem",
      "click a": "deactivate",
      "dblclick a[href = #toc]": "toggle"
    },

    initialize: function () {
      this.render();
    },

    render: function () {
      $(".nav-tabs li a:not([href='#search'])").on("shown.bs.tab", function () {
        globals.content.unset("highlight");
      });

      $("#navpane ul li a").on("click", function (event) {
        $("#encoreSection").attr("style","display: none !important;");
        $("#contentSection").show();
      });
      $("#encoreTab").on("click", function (event) {
        $("#encoreSection").show();
        $("#contentSection").attr("style","display: none !important;");
      });
      $("a.encorelink").on("click", function (event) {
        event.preventDefault();
        $("iframe#encore").attr("src", $(this).attr("href"))

        return false;
      });
    },

    deactivate: function () {
      return !$("body").hasClass("wide") ? this : this.toggle();
    },

    toggle: function () {
      if (!globals.options.ui.wide) return this;
      $("body").find(".breadcrumb")
               .toggleClass("hidden-md hidden-lg hidden-sm");

      return this.saveState();
    },

    saveState: function () {
      // TODO: Why is this done?
      if (_.has(window, "localStorage")) {
        window.localStorage.setItem("state", JSON.stringify(globals.state));
      }

      return this;
    }
  });
});

